<template>
  <div class="post d-flex flex-column-fluid pt-0 bg-lighten">
    <div class="container-xxl p-0" ref="errosGerais">
      <div
        v-if="loading"
        class="ms-7 mb-7 pt-5"
        v-bind:data-kt-indicator="loading ? 'on' : 'off'"
      >
        <span class="indicator-progress">
          Aguarde, carregando...
          <span
            class="spinner-border spinner-border-sm align-middle ms-2"
          ></span>
        </span>
      </div>
      <div
        v-if="this.errosGerais.Message"
        class="notice d-flex bg-light-danger rounded border-danger border border-dashed ms-7 me-7 mb-9 p-6"
      >
        <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
          <inline-svg src="media/icons/duotune/general/gen044.svg" />
        </span>
        <div class="d-flex flex-stack flex-grow-1">
          <div class="fw-bold">
            <h4 class="text-gray-800 fw-bolder">Aviso</h4>
            <div class="fs-6 text-gray-600">
              {{ this.errosGerais.Message }}
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="this.errosValidacaoGeral.length && !this.loading"
        class="notice d-flex bg-light-danger rounded border-danger border border-dashed ms-7 me-7 mb-9 p-6"
      >
        <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
          <inline-svg src="media/icons/duotune/general/gen044.svg" />
        </span>
        <div class="d-flex flex-stack flex-grow-1">
          <div class="fw-bold">
            <h4 class="text-gray-800 fw-bolder">Aviso</h4>
            <div class="fs-6 text-gray-600">
              <ul>
                <li v-for="value in this.errosValidacaoGeral" :key="value">
                  {{ value }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!loading" class="d-flex flex-column flex-lg-row px-7 pt-5">
        <div
          class="d-flex flex-column gap-6 gap-lg-10 w-100 w-lg-300px min-w-sm-300px mb-7 me-lg-10"
        >
          <div class="card card-flush py-4">
            <div class="card-header">
              <div class="card-title">
                <h2>Foto</h2>
              </div>
            </div>
            <div class="card-body text-center pt-0">
              <div
                id="imgFoto"
                class="image-input image-input-outline"
                data-kt-image-input="true"
              >
                <div
                  class="image-input-wrapper imagePreviewWrapper w-150px h-150px"
                  v-if="fornecedor && fornecedor.foto"
                  :style="{ 'background-image': `url(${fornecedor.foto})` }"
                ></div>
                <div
                  class="image-input-wrapper imagePreviewWrapper w-150px h-150px"
                  v-else
                  :style="{
                    'background-image': `url(media/svg/files/blank-image.svg)`,
                  }"
                ></div>
                <label
                  class="btn btn-icon btn-circle btn-active-color-primary w-30px h-30px bg-white shadow"
                  data-kt-image-input-action="change"
                  data-bs-toggle="tooltip"
                  data-bs-dismiss="click"
                  title="Alterar foto"
                >
                  <i class="bi bi-pencil-fill fs-7"></i>
                  <input
                    ref="fileInput"
                    type="file"
                    name="avatar"
                    accept=".png, .jpg, .jpeg"
                    @input="pickFile"
                  />
                  <input type="hidden" name="avatar_remove" />
                </label>
                <span
                  class="btn btn-icon btn-circle btn-active-color-primary w-30px h-30px bg-white shadow"
                  data-kt-image-input-action="remove"
                  data-bs-toggle="tooltip"
                  @click="removerFoto()"
                  data-bs-dismiss="click"
                  title="Remover foto"
                >
                  <i class="bi bi-x fs-2"></i>
                </span>
              </div>
              <div class="form-text mt-6">
                Selecione uma foto. Apenas *.png, *.jpg e *.jpeg aquivo de foto
                é aceito
              </div>
            </div>
          </div>
          <div class="card card-flush py-4">
            <div class="card-header">
              <div class="card-title">
                <h2>Situação</h2>
              </div>
              <div class="card-toolbar">
                <div
                  class="rounded-circle w-15px h-15px"
                  :class="[
                    fornecedor.ativo === '1' ? 'bg-success' : 'bg-danger',
                  ]"
                ></div>
              </div>
            </div>
            <div class="card-body pt-0">
              <select
                class="form-select mb-2"
                data-placeholder="Selecione uma opção"
                v-model="fornecedor.ativo"
              >
                <option value="1">Ativo</option>
                <option value="0">Indisponível</option>
              </select>
              <div class="text-muted fs-7">Defina a situação do fornecedor</div>
            </div>
          </div>
          <div class="card card-flush py-4">
            <div class="card-header">
              <div class="card-title">
                <h2>Física / Jurídica</h2>
              </div>
            </div>
            <div class="card-body pt-0">
              <select
                class="form-select mb-2"
                data-placeholder="Selecione uma opção"
                v-model="fornecedor.fisica"
              >
                <option value="F">Física</option>
                <option value="J">Jurídica</option>
              </select>
              <div class="text-muted fs-7">Defina a natureza do fornecedor</div>
            </div>
          </div>
        </div>
        <div class="d-flex flex-column flex-row-fluid gap-6 mb-7 gap-lg-10">
          <ul
            class="nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-bold mb-n2"
          >
            <li class="nav-item">
              <a
                ref="tabGeral"
                class="nav-link text-active-primary pb-4 active"
                data-bs-toggle="tab"
                href="#kt_fornecedor_geral"
                >Geral</a
              >
            </li>
            <li v-if="this.consultarFornecedorEndereco" class="nav-item">
              <a
                ref="tabEnderecos"
                class="nav-link text-active-primary pb-4"
                data-bs-toggle="tab"
                href="#kt_fornecedor_enderecos"
                >Endereços</a
              >
            </li>
            <li v-if="this.consultarFornecedorTelefone" class="nav-item">
              <a
                ref="tabTelefones"
                class="nav-link text-active-primary pb-4"
                data-bs-toggle="tab"
                href="#kt_fornecedor_telefones"
                >Telefones</a
              >
            </li>
            <li v-if="this.consultarFornecedorEmail" class="nav-item">
              <a
                ref="tabEmails"
                class="nav-link text-active-primary pb-4"
                data-bs-toggle="tab"
                href="#kt_fornecedor_emails"
                >Emails</a
              >
            </li>
            <li class="nav-item">
              <a
                ref="tabObservacoes"
                class="nav-link text-active-primary pb-4"
                data-bs-toggle="tab"
                href="#kt_fornecedor_observacoes"
                >Observações</a
              >
            </li>
          </ul>
          <div class="tab-content">
            <div
              class="tab-pane fade show active"
              id="kt_fornecedor_geral"
              role="tab-panel"
            >
              <div class="d-flex flex-column gap-7 gap-lg-10">
                <div class="card card-flush py-4">
                  <div class="card-header">
                    <div class="card-title">
                      <h2>Geral</h2>
                    </div>
                  </div>
                  <div class="card-body pt-0 pb-0">
                    <div class="row">
                      <div
                        class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-2"
                      >
                        <div class="mb-10 fv-row">
                          <label for="txtNome" class="required form-label"
                            >Nome / Razão social</label
                          >
                          <input
                            type="text"
                            id="txtNome"
                            :value="
                              (fornecedor.nome = fornecedor.nome.toUpperCase())
                            "
                            @input="
                              fornecedor.nome =
                                $event.target.value.toUpperCase()
                            "
                            class="form-control"
                          />
                          <div
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ errosValidacao["nome"] }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-2"
                      >
                        <div class="mb-10 fv-row">
                          <label for="txtFantasia" class="form-label"
                            >Fantasia</label
                          >
                          <input
                            type="text"
                            id="txtFantasia"
                            class="form-control"
                            :value="
                              (fornecedor.fantasia = fornecedor.fantasia
                                ? fornecedor.fantasia.toUpperCase()
                                : '')
                            "
                            @input="
                              fornecedor.fantasia =
                                $event.target.value.toUpperCase()
                            "
                          />
                          <div
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ errosValidacao["fantasia"] }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div
                        class="col-sm-12 col-md-12 col-lg-12 col-xl-7 col-xxl-7 mb-2"
                      >
                        <div class="mb-10 fv-row">
                          <label for="txtCPFCNPJ" class="required form-label"
                            >CPF / CNPJ</label
                          >
                          <div class="input-group">
                            <input
                              type="text"
                              id="txtCPFCNPJ"
                              class="form-control"
                              v-mask="['###.###.###-##', '##.###.###/####-##']"
                              v-model="fornecedor.cpf_cnpj"
                            />
                            <button
                              @click.prevent="pesquisarCNPJ()"
                              class="input-group-text"
                              v-bind:data-kt-indicator="
                                loadingCNPJ ? 'on' : 'off'
                              "
                            >
                              <span
                                class="svg-icon svg-icon-2"
                                v-if="!loadingCNPJ"
                              >
                                <inline-svg
                                  src="media/icons/duotune/general/gen004.svg"
                                />
                              </span>
                              <span class="indicator-progress">
                                <span
                                  class="spinner-border align-middle"
                                  style="width: 1.5rem; height: 1.5rem"
                                ></span>
                              </span>
                            </button>
                          </div>

                          <div
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ errosValidacao["cpf_cnpj"] }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-sm-12 col-md-12 col-lg-12 col-xl-5 col-xxl-5 mb-2"
                      >
                        <div class="mb-10 fv-row">
                          <label for="txtContato" class="form-label"
                            >Contato</label
                          >
                          <div class="input-group">
                            <span class="input-group-text" id="basic-addon3">
                              <i class="bi bi-person-fill fs-3"></i>
                            </span>
                            <input
                              type="text"
                              id="txtContato"
                              class="form-control"
                              v-model="fornecedor.contato"
                            />
                          </div>
                          <div
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ errosValidacao["contato"] }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div
                        class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 mb-2"
                      >
                        <div class="mb-10 fv-row">
                          <label for="txtRGIE" class="form-label"
                            >RG / IE</label
                          >
                          <input
                            type="text"
                            id="txtRGIE"
                            class="form-control"
                            v-model="fornecedor.rg_ie"
                          />
                          <div
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ errosValidacao["rg_ie"] }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 mb-2"
                      >
                        <div class="mb-10 fv-row">
                          <label for="txtSite" class="form-label">Site</label>
                          <div class="input-group">
                            <span class="input-group-text" id="basic-addon3">
                              <i class="bi bi-globe2 fs-3"></i>
                            </span>
                            <input
                              type="text"
                              id="txtSite"
                              class="form-control"
                              v-model="fornecedor.site"
                            />
                          </div>
                          <div
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ errosValidacao["site"] }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div
                        class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-3 mb-2"
                      >
                        <div class="mb-10 fv-row">
                          <label class="form-label">Conta</label>
                          <div class="input-group">
                            <input
                              type="text"
                              class="form-control"
                              v-model="this.fornecedor.id_conta"
                            />
                            <button
                              class="input-group-text"
                              @click="this.modalContas(true)"
                            >
                              <span class="svg-icon svg-icon-2">
                                <inline-svg
                                  src="media/icons/duotune/general/gen004.svg"
                                />
                              </span>
                            </button>
                          </div>
                          <div
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ errosValidacao["id_conta"] }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-3 mb-2"
                      >
                        <div class="mb-10 fv-row">
                          <label class="form-label">Custo</label>
                          <div class="input-group">
                            <input
                              type="text"
                              class="form-control"
                              v-model="this.fornecedor.id_custo"
                              readonly
                            />
                            <button
                              class="input-group-text"
                              @click="this.modalCustos(true)"
                            >
                              <span class="svg-icon svg-icon-2">
                                <inline-svg
                                  src="media/icons/duotune/general/gen004.svg"
                                />
                              </span>
                            </button>
                          </div>
                          <div
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ errosValidacao["id_custo"] }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-6 mb-2"
                      >
                        <div class="mb-10 fv-row">
                          <label class="form-label">Regime Tributário</label>
                          <select
                            class="form-select mb-2"
                            data-placeholder="Selecione uma opção"
                            v-model="fornecedor.tipo_regime"
                          >
                            <option value="0">0 - Simples Nacional</option>
                            <option value="1">1 - Lucro Presumido</option>
                            <option value="2">2 - Lucro Real</option>
                          </select>
                          <div
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ errosValidacao["tipo_regime"] }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="kt_fornecedor_enderecos"
              role="tab-panel"
            >
              <div class="d-flex flex-column gap-7 gap-lg-10">
                <div class="card card-flush py-4">
                  <div class="card-header">
                    <div class="card-title" ref="fornecedor_endereco">
                      <h2>Endereços</h2>
                    </div>
                  </div>
                  <div class="card-body pt-0 pb-0">
                    <div
                      v-if="this.errosGeraisEndereco.Message"
                      class="notice d-flex bg-light-danger rounded border-danger border border-dashed mb-9 p-6"
                    >
                      <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
                        <inline-svg
                          src="media/icons/duotune/general/gen044.svg"
                        />
                      </span>
                      <div class="d-flex flex-stack flex-grow-1">
                        <div class="fw-bold">
                          <h4 class="text-gray-800 fw-bolder">Aviso</h4>
                          <div class="fs-6 text-gray-600">
                            {{ this.errosGeraisEndereco.Message }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="row mb-6"
                      v-for="(endereco, i) in this.fornecedor
                        .FornecedorEndereco"
                      v-bind:key="i"
                    >
                      <div
                        v-if="i != 0"
                        class="separator border-2 separator-dashed border-gray-300 mb-10"
                      ></div>
                      <div class="col-xl-6 col-xxl-4 fv-row mb-6">
                        <label class="form-label required fw-bold fs-6"
                          >Descrição</label
                        >
                        <select
                          class="form-select"
                          v-model="endereco.descricao"
                          :disabled="
                            this.add === false &&
                            this.editarFornecedorEndereco === false
                          "
                        >
                          <option value="Casa">Casa</option>
                          <option value="Trabalho">Trabalho</option>
                          <option value="Comercial">Comercial</option>
                          <option value="Outro">Outro</option>
                        </select>
                        <div
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{
                            errosValidacao[
                              "FornecedorEndereco[" + i + "]descricao"
                            ]
                          }}
                          {{
                            errosValidacaoEndereco[i]
                              ? errosValidacaoEndereco[i]["descricao"]
                              : ""
                          }}
                        </div>
                      </div>
                      <div class="col-xl-6 col-xxl-4 fv-row mb-6">
                        <label class="form-label fw-bold fs-6">CEP</label>
                        <div class="input-group">
                          <input
                            type="text"
                            v-on:keyup.enter="pesquisarCep(i)"
                            class="form-control"
                            v-mask="'#####-###'"
                            v-model="endereco.cep"
                            :disabled="
                              this.add === false &&
                              this.editarFornecedorEndereco === false
                            "
                          />
                          <button
                            @click="pesquisarCep(i)"
                            class="input-group-text"
                            v-bind:data-kt-indicator="loadingCep ? 'on' : 'off'"
                          >
                            <span
                              class="svg-icon svg-icon-2"
                              v-if="!loadingCep"
                            >
                              <inline-svg
                                src="media/icons/duotune/general/gen004.svg"
                              />
                            </span>
                            <span class="indicator-progress">
                              <span
                                class="spinner-border align-middle"
                                style="width: 1.5rem; height: 1.5rem"
                              ></span>
                            </span>
                          </button>
                        </div>
                        <div
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{
                            errosValidacao["FornecedorEndereco[" + i + "]cep"]
                          }}
                          {{
                            errosValidacaoEndereco[i]
                              ? errosValidacaoEndereco[i]["cep"]
                              : ""
                          }}
                        </div>
                      </div>
                      <div class="col-xxl-8 fv-row mb-6">
                        <label class="form-label fw-bold fs-6">Endereço</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="endereco.endereco"
                          :disabled="
                            this.add === false &&
                            this.editarFornecedorEndereco === false
                          "
                        />
                        <div
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{
                            errosValidacao[
                              "FornecedorEndereco[" + i + "]endereco"
                            ]
                          }}
                          {{
                            errosValidacaoEndereco[i]
                              ? errosValidacaoEndereco[i]["endereco"]
                              : ""
                          }}
                        </div>
                      </div>
                      <div class="col-xl-5 col-xxl-4 fv-row mb-6">
                        <label class="form-label fw-bold fs-6">Número</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="endereco.numero"
                          :disabled="
                            this.add === false &&
                            this.editarFornecedorEndereco === false
                          "
                        />
                        <div
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{
                            errosValidacao[
                              "FornecedorEndereco[" + i + "]numero"
                            ]
                          }}
                          {{
                            errosValidacaoEndereco[i]
                              ? errosValidacaoEndereco[i]["numero"]
                              : ""
                          }}
                        </div>
                      </div>
                      <div class="col-xl-7 col-xxl-6 fv-row mb-6">
                        <label class="form-label fw-bold fs-6"
                          >Complemento</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          v-model="endereco.complemento"
                          :disabled="
                            this.add === false &&
                            this.editarFornecedorEndereco === false
                          "
                        />
                        <div
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{
                            errosValidacao[
                              "FornecedorEndereco[" + i + "]complemento"
                            ]
                          }}
                          {{
                            errosValidacaoEndereco[i]
                              ? errosValidacaoEndereco[i]["complemento"]
                              : ""
                          }}
                        </div>
                      </div>
                      <div class="col-xxl-6 fv-row mb-6">
                        <label class="form-label fw-bold fs-6">Bairro</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="endereco.bairro"
                          :disabled="
                            this.add === false &&
                            this.editarFornecedorEndereco === false
                          "
                        />
                        <div
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{
                            errosValidacao[
                              "FornecedorEndereco[" + i + "]bairro"
                            ]
                          }}
                          {{
                            errosValidacaoEndereco[i]
                              ? errosValidacaoEndereco[i]["bairro"]
                              : ""
                          }}
                        </div>
                      </div>
                      <div class="col-xxl-4 fv-row mb-6">
                        <label class="form-label required fw-bold fs-6"
                          >UF</label
                        >
                        <select
                          class="form-select"
                          v-model="endereco.uf"
                          :disabled="
                            this.add === false &&
                            this.editarFornecedorEndereco === false
                          "
                        >
                          <option value="AC">Acre</option>
                          <option value="AL">Alagoas</option>
                          <option value="AP">Amapá</option>
                          <option value="AM">Amazonas</option>
                          <option value="BA">Bahia</option>
                          <option value="CE">Ceara</option>
                          <option value="DF">Distrito Federal</option>
                          <option value="ES">Espirito Santo</option>
                          <option value="GO">Goiás</option>
                          <option value="MA">Maranhão</option>
                          <option value="MT">Mato Grosso</option>
                          <option value="MS">Mato Grosso do Sul</option>
                          <option value="MG">Minas Gerais</option>
                          <option value="PA">Para</option>
                          <option value="PB">Paraíba</option>
                          <option value="PR">Paraná</option>
                          <option value="PE">Pernambuco</option>
                          <option value="PI">Piauí</option>
                          <option value="RJ">Rio de Janeiro</option>
                          <option value="RN">Rio Grande do Norte</option>
                          <option value="RS">Rio Grande do Sul</option>
                          <option value="RO">Rondônia</option>
                          <option value="RR">Roraima</option>
                          <option value="SC">Santa Catarina</option>
                          <option value="SP">São Paulo</option>
                          <option value="SE">Sergipe</option>
                          <option value="TO">Tocantins</option>
                        </select>
                        <div
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{
                            errosValidacao["FornecedorEndereco[" + i + "]uf"]
                          }}
                          {{
                            errosValidacaoEndereco[i]
                              ? errosValidacaoEndereco[i]["uf"]
                              : ""
                          }}
                        </div>
                      </div>
                      <div class="col-xxl-5 fv-row mb-6">
                        <label class="form-label required fw-bold fs-6"
                          >Cidade</label
                        >
                        <div class="input-group">
                          <input
                            type="text"
                            class="form-control"
                            :value="
                              endereco.cidade
                                ? endereco.cidade.toUpperCase()
                                : ''
                            "
                            @input="
                              endereco.cidade =
                                $event.target.value.toUpperCase()
                            "
                            :disabled="
                              this.add === false &&
                              this.editarFornecedorEndereco === false
                            "
                          />
                          <button
                            class="input-group-text"
                            @click="exibirModalCidades(true, i)"
                          >
                            <span class="svg-icon svg-icon-2">
                              <inline-svg
                                src="media/icons/duotune/general/gen004.svg"
                              />
                            </span>
                          </button>
                        </div>
                        <div
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{
                            errosValidacao[
                              "FornecedorEndereco[" + i + "]cidade"
                            ]
                          }}
                          {{
                            errosValidacaoEndereco[i]
                              ? errosValidacaoEndereco[i]["cidade"]
                              : ""
                          }}
                        </div>
                      </div>
                      <div class="col-xxl-3 fv-row mb-6">
                        <label class="form-label required fw-bold fs-6"
                          >País</label
                        >
                        <div class="input-group">
                          <input
                            type="text"
                            class="form-control"
                            :value="
                              endereco.pais ? endereco.pais.toUpperCase() : ''
                            "
                            @input="
                              endereco.pais = $event.target.value.toUpperCase()
                            "
                            :disabled="
                              this.add === false &&
                              this.editarFornecedorEndereco === false
                            "
                          />
                          <button
                            class="input-group-text"
                            @click="exibirModalPaises(true, i)"
                          >
                            <span class="svg-icon svg-icon-2">
                              <inline-svg
                                src="media/icons/duotune/general/gen004.svg"
                              />
                            </span>
                          </button>
                        </div>
                        <div
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{
                            errosValidacao["FornecedorEndereco[" + i + "]pais"]
                          }}
                          {{
                            errosValidacaoEndereco[i]
                              ? errosValidacaoEndereco[i]["pais"]
                              : ""
                          }}
                        </div>
                      </div>
                      <div class="col-xl-6 col-xxl-3 fv-row mb-6">
                        <label class="form-label fw-bold fs-6">Latitude</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="endereco.latitude"
                          :disabled="
                            this.add === false &&
                            this.editarFornecedorEndereco === false
                          "
                        />
                        <div
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{
                            errosValidacao[
                              "FornecedorEndereco[" + i + "]latitude"
                            ]
                          }}
                          {{
                            errosValidacaoEndereco[i]
                              ? errosValidacaoEndereco[i]["latitude"]
                              : ""
                          }}
                        </div>
                      </div>
                      <div class="col-xl-6 col-xxl-3 fv-row mb-6">
                        <label class="form-label fw-bold fs-6">Longitude</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="endereco.longitude"
                          :disabled="
                            this.add === false &&
                            this.editarFornecedorEndereco === false
                          "
                        />
                        <div
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{
                            errosValidacao[
                              "FornecedorEndereco[" + i + "]longitude"
                            ]
                          }}
                          {{
                            errosValidacaoEndereco[i]
                              ? errosValidacaoEndereco[i]["longitude"]
                              : ""
                          }}
                        </div>
                      </div>
                      <div class="col-xxl-4 fv-row mb-6 mt-xxl-8">
                        <button
                          v-if="this.excluirFornecedorEndereco"
                          @click="excluirEndereco(i)"
                          class="btn btn-light-danger svg-icon-white me-2 mb-2"
                        >
                          <i class="la la-trash-o me-2 fs-3"></i>Excluír
                        </button>
                      </div>
                    </div>
                    <div class="form-group mt-5 mb-10">
                      <button
                        v-if="this.adicionarFornecedorEndereco"
                        @click="adicionarEndereco()"
                        class="btn btn-light-primary"
                      >
                        <i class="la la-plus me-2 fs-3"></i>Adicionar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="kt_fornecedor_telefones"
              role="tab-panel"
            >
              <div class="d-flex flex-column gap-7 gap-lg-10">
                <div class="card card-flush py-4">
                  <div class="card-header">
                    <div class="card-title" ref="fornecedor_telefone">
                      <h2>Telefones</h2>
                    </div>
                  </div>
                  <div class="card-body pt-0 pb-0">
                    <div
                      v-if="this.errosGeraisTelefone.Message"
                      class="notice d-flex bg-light-danger rounded border-danger border border-dashed mb-9 p-6"
                    >
                      <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
                        <inline-svg
                          src="media/icons/duotune/general/gen044.svg"
                        />
                      </span>
                      <div class="d-flex flex-stack flex-grow-1">
                        <div class="fw-bold">
                          <h4 class="text-gray-800 fw-bolder">Aviso</h4>
                          <div class="fs-6 text-gray-600">
                            {{ this.errosGeraisTelefone.Message }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="row mb-6"
                      v-for="(telefone, i) in this.fornecedor
                        .FornecedorTelefone"
                      v-bind:key="i"
                    >
                      <div class="col-xl-5 col-xxl-4 fv-row mb-6">
                        <label class="form-label required fw-bold fs-6"
                          >Descrição</label
                        >
                        <select
                          class="form-select"
                          v-model="telefone.descricao"
                          :disabled="
                            this.add === false &&
                            this.editarFornecedorTelefone === false
                          "
                        >
                          <option value="Celular">Celular</option>
                          <option value="Telefone">Telefone</option>
                          <option value="Casa">Casa</option>
                          <option value="Comercial">Comercial</option>
                          <option value="Fax Residencial">
                            Fax Residencial
                          </option>
                          <option value="Fax Comercial">Fax Comercial</option>
                          <option value="Outro">Outro</option>
                        </select>
                        <div
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{
                            errosValidacao[
                              "FornecedorTelefone[" + i + "]descricao"
                            ]
                          }}
                          {{
                            errosValidacaoTelefone[i]
                              ? errosValidacaoTelefone[i]["descricao"]
                              : ""
                          }}
                        </div>
                      </div>
                      <div class="col-xl-7 col-xxl-5 fv-row mb-6">
                        <label for="txtTelefone" class="form-label"
                          >Número</label
                        >
                        <div class="input-group">
                          <span class="input-group-text" id="basic-addon3">
                            <i class="bi bi-telephone fs-3"></i>
                          </span>
                          <input
                            type="text"
                            id="txtTelefone"
                            class="form-control"
                            v-mask="['(##) ####-####', '(##) #####-####']"
                            v-model="telefone.telefone"
                            :disabled="
                              this.add === false &&
                              this.editarFornecedorTelefone === false
                            "
                          />
                        </div>
                        <div
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{
                            errosValidacao[
                              "FornecedorTelefone[" + i + "]telefone"
                            ]
                          }}
                          {{
                            errosValidacaoTelefone[i]
                              ? errosValidacaoTelefone[i]["telefone"]
                              : ""
                          }}
                        </div>
                      </div>
                      <div class="col-xxl-3 fv-row mb-6 mt-xxl-8">
                        <button
                          v-if="this.excluirFornecedorTelefone"
                          @click="excluirTelefone(i)"
                          class="btn btn-light-danger svg-icon-white me-2 mb-2"
                        >
                          <i class="la la-trash-o me-2 fs-3"></i>Excluír
                        </button>
                      </div>
                    </div>
                    <div class="form-group mt-5 mb-10">
                      <button
                        v-if="this.adicionarFornecedorTelefone"
                        @click="adicionarTelefone()"
                        class="btn btn-light-primary"
                      >
                        <i class="la la-plus me-2 fs-3"></i>Adicionar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="kt_fornecedor_emails"
              role="tab-panel"
            >
              <div class="d-flex flex-column gap-7 gap-lg-10">
                <div class="card card-flush py-4">
                  <div class="card-header">
                    <div class="card-title" ref="fornecedor_email">
                      <h2>Emails</h2>
                    </div>
                  </div>
                  <div class="card-body pt-0 pb-0">
                    <div
                      v-if="this.errosGeraisEmail.Message"
                      class="notice d-flex bg-light-danger rounded border-danger border border-dashed mb-9 p-6"
                    >
                      <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
                        <inline-svg
                          src="media/icons/duotune/general/gen044.svg"
                        />
                      </span>
                      <div class="d-flex flex-stack flex-grow-1">
                        <div class="fw-bold">
                          <h4 class="text-gray-800 fw-bolder">Aviso</h4>
                          <div class="fs-6 text-gray-600">
                            {{ this.errosGeraisEmail.Message }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="row mb-6"
                      v-for="(email, i) in this.fornecedor.FornecedorEmail"
                      v-bind:key="i"
                    >
                      <div class="col-xl-5 col-xxl-4 fv-row mb-6">
                        <label class="form-label required fw-bold fs-6"
                          >Descrição</label
                        >
                        <select
                          class="form-select"
                          v-model="email.descricao"
                          :disabled="
                            this.add === false &&
                            this.editarFornecedorEmail === false
                          "
                        >
                          <option value="Pessoal">Pessoal</option>
                          <option value="Cobrança">Cobrança</option>
                          <option value="Comercial">Comercial</option>
                          <option value="Outros">Outros</option>
                        </select>
                        <div
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{
                            errosValidacao[
                              "FornecedorEmail[" + i + "]descricao"
                            ]
                          }}
                          {{
                            errosValidacaoEmail[i]
                              ? errosValidacaoEmail[i]["descricao"]
                              : ""
                          }}
                        </div>
                      </div>
                      <div class="col-xl-7 col-xxl-5 fv-row mb-6">
                        <label for="txtEmail" class="form-label">Email</label>
                        <div class="input-group">
                          <span class="input-group-text" id="basic-addon3">
                            <i class="bi bi-at fs-3"></i>
                          </span>
                          <input
                            type="text"
                            id="txtEmail"
                            class="form-control"
                            v-model="email.email"
                            :disabled="
                              this.add === false &&
                              this.editarFornecedorEmail === false
                            "
                          />
                        </div>
                        <div
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{
                            errosValidacao["FornecedorEmail[" + i + "]email"]
                          }}
                          {{
                            errosValidacaoEmail[i]
                              ? errosValidacaoEmail[i]["email"]
                              : ""
                          }}
                        </div>
                      </div>
                      <div class="col-xxl-3 fv-row mb-6 mt-xxl-8">
                        <button
                          v-if="this.excluirFornecedorEmail"
                          @click="excluirEmail(i)"
                          class="btn btn-light-danger svg-icon-white me-2 mb-2"
                        >
                          <i class="la la-trash-o me-2 fs-3"></i>Excluír
                        </button>
                      </div>
                    </div>
                    <div class="form-group mt-5 mb-10">
                      <button
                        v-if="this.adicionarFornecedorEmail"
                        @click="adicionarEmail()"
                        class="btn btn-light-primary"
                      >
                        <i class="la la-plus me-2 fs-3"></i>Adicionar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="kt_fornecedor_observacoes"
              role="tab-panel"
            >
              <div class="d-flex flex-column gap-7 gap-lg-10">
                <div class="card card-flush py-4">
                  <div class="card-header">
                    <div class="card-title">
                      <h2>Observações</h2>
                    </div>
                  </div>
                  <div class="card-body pt-0 pb-0">
                    <div class="mb-5 fv-row">
                      <label class="form-label">Observações</label>
                      <textarea
                        id="txtObservacoes"
                        class="form-control mb-2"
                        placeholder="Observações do fornecedor"
                        maxlength="500"
                        style="height: 250px"
                        v-model="fornecedor.observacoes"
                      />
                      <div class="row">
                        <div class="col-6 pe-0">
                          <div
                            class="fv-plugins-message-container invalid-feedback m-0"
                          >
                            {{ errosValidacao["observacoes"] }}
                          </div>
                        </div>
                        <div class="col-6 ps-2">
                          <div class="text-end text-muted fs-7">
                            {{
                              fornecedor.observacoes
                                ? fornecedor.observacoes.length
                                : "0"
                            }}/500 caracteres
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-end">
            <button
              v-if="this.modal === true"
              class="btn btn-danger svg-icon-white me-2 mb-2"
              data-bs-dismiss="modal"
              @click="$emit('cancelarFornecedor', false)"
            >
              <span class="svg-icon svg-icon-1">
                <inline-svg
                  src="media/icons/duotune/arrows/arr015.svg"
                  class="me-2"
                />Cancelar
              </span>
            </button>
            <router-link
              v-else
              to="/cadastros/fornecedores/consultar"
              class="btn btn-danger svg-icon-white me-2 mb-2"
            >
              <span class="svg-icon svg-icon-1">
                <inline-svg
                  src="media/icons/duotune/arrows/arr015.svg"
                  class="me-2"
                />Cancelar
              </span>
            </router-link>
            <button
              class="btn btn-success svg-icon-white mb-2"
              @click="confirmarFornecedor()"
              v-bind:data-kt-indicator="this.loading ? 'on' : 'off'"
            >
              <span class="indicator-progress">
                <span
                  class="spinner-border spinner-border-sm align-middle ms-1"
                ></span>
                Aguarde...
              </span>
              <span class="svg-icon svg-icon-1" v-if="!this.loading">
                <inline-svg
                  src="media/icons/duotune/arrows/arr016.svg"
                  class="me-2"
                />Confirmar
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <CidadesModal
    v-if="exibirCidades"
    @exibirModalCidades="modalCidades"
    @confirmarCidade="confirmarCidade"
  ></CidadesModal>
  <PaisesModal
    v-if="exibirPaises"
    @exibirModalPaises="modalPaises"
    @confirmarPais="confirmarPais"
  ></PaisesModal>
  <ContasModal
    v-if="exibirContas"
    @exibirModalContas="modalContas"
    @selecionarConta="selecionarConta"
  ></ContasModal>
  <CustosModal
    v-if="exibirCustos"
    @exibirModalCustos="modalCustos"
    @selecionarCusto="selecionarCusto"
  ></CustosModal>
</template>

<script>
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import CidadesModal from "@/views/cidades/CidadesModal.vue";
import PaisesModal from "@/views/paises/PaisesModal";
import ContasModal from "@/views/contas/ContasModal.vue";
import CustosModal from "@/views/custos/CustosModal.vue";
import { mapState } from "vuex";
import { useToast } from "vue-toastification";
const toast = useToast();
import {
  hideModal,
  showModal,
  getOrCreateInstanceModal,
} from "@/core/helpers/dom";

export default {
  emits: ["cancelarFornecedor", "confirmarFornecedor"],
  components: {
    CidadesModal,
    PaisesModal,
    ContasModal,
    CustosModal,
  },
  props: {
    idFornecedor: { type: Number, required: false, default: 0 },
    modal: { type: Boolean, required: false, default: false },
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  methods: {
    selecionarConta(conta) {
      this.fornecedor.id_conta = conta.id;
    },
    modalContas(exibir) {
      this.exibirContas = exibir;
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal("kt_modal_contas_consultar");
        }, 100);
      }
    },
    selecionarCusto(custo) {
      this.fornecedor.id_custo = custo.id;
    },
    modalCustos(exibir) {
      this.exibirCustos = exibir;
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal("kt_modal_custos_consultar");
        }, 100);
      }
    },
    async confirmarFornecedor() {
      this.errosGerais = {};
      this.errosValidacao = [];
      this.errosValidacaoGeral = [];
      this.errosGeraisTelefone = {};
      this.errosValidacaoTelefone = [];
      this.errosGeraisEndereco = {};
      this.errosValidacaoEndereco = [];
      this.errosGeraisEmail = {};
      this.errosValidacaoEmail = [];
      this.loading = true;
      this.confirmouCadastro = true;

      this.fornecedor.fantasia =
        this.fornecedor.fantasia === null ? "" : this.fornecedor.fantasia;
      this.fornecedor.cpf_cnpj = this.$utils.unMask(this.fornecedor.cpf_cnpj);
      this.fornecedor.rg_ie = this.$utils.unMask(this.fornecedor.rg_ie);
      this.fornecedor.contato =
        this.fornecedor.contato === null ? "" : this.fornecedor.contato;
      this.fornecedor.site =
        this.fornecedor.site === null ? "" : this.fornecedor.site;
      this.fornecedor.observacoes =
        this.fornecedor.observacoes === null ? "" : this.fornecedor.observacoes;

      this.fornecedor.foto =
        this.fornecedor.foto === null
          ? ""
          : this.fornecedor.foto.replace(this.$utils.getUrl(), "");

      if (this.fornecedor.id === 0) {
        this.fornecedor.guid = this.$utils.generateUuidv4();
      }

      var formData = this.$utils.convertModelToFormData(this.fornecedor);
      if (this.fornecedor.id === 0) {
        try {
          var ret = await this.$store.dispatch(
            "fornecedor/postFornecedor",
            formData
          );
          if (ret.Success === true) {
            this.fornecedor.id = ret.Data.id;
            await this.confirmarEndereco();
            await this.confirmarTelefone();
            await this.confirmarEmail();
          }
        } catch (error) {
          this.errosValidacaoGeral.push(
            ...this.$utils.retornarValoresJson(error)
          );
          this.errosGerais = error;
          this.errosValidacao = error;
          this.confirmouCadastro = false;
        }
      } else {
        try {
          var retPut = await this.$store.dispatch(
            "fornecedor/putFornecedor",
            formData
          );
          if (retPut.Success === true) {
            await this.confirmarEndereco();
            await this.confirmarTelefone();
            await this.confirmarEmail();
          }
        } catch (error) {
          this.errosValidacaoGeral.push(
            ...this.$utils.retornarValoresJson(error)
          );
          this.errosGerais = error;
          this.errosValidacao = error;
          this.confirmouCadastro = false;
        }
      }

      if (
        this.fornecedor.foto !== "" &&
        !this.fornecedor.foto.includes("base64")
      ) {
        this.fornecedor.foto = this.$utils.getUrl() + this.fornecedor.foto;
      }

      if (this.errosGerais.Message) {
        this.scroll("errosGerais");
      }

      this.loading = false;

      if (this.confirmouCadastro === true) {
        toast.success("Cadastro salvo com sucesso!", { timeout: 3000 });
        if (this.modal === true) {
          this.$emit("confirmarFornecedor");
        } else {
          this.$router.push("/cadastros/fornecedores/consultar");
        }
      } else {
        toast.error("Ocorreu uma falha ao gravar o cadastro, verifique!", {
          timeout: 5000,
        });
      }
    },
    async confirmarEndereco() {
      this.errosValidacaoEndereco = new Array(
        this.fornecedor.FornecedorEndereco.length
      );
      for (var i = 0; i < this.fornecedor.FornecedorEndereco.length; i++) {
        if (this.fornecedor.FornecedorEndereco[i].id === 0) {
          this.fornecedor.FornecedorEndereco[i].id_fornecedor =
            this.fornecedor.id;
          try {
            var ret = await this.$store.dispatch(
              "fornecedorEndereco/postFornecedorEndereco",
              this.fornecedor.FornecedorEndereco[i]
            );
            if (ret.Success === true) {
              this.fornecedor.FornecedorEndereco[i].id = ret.Data.id;
            }
          } catch (error) {
            this.errosValidacaoGeral.push(
              ...this.$utils.retornarValoresJson(error)
            );
            this.errosGerais = error;
            this.errosValidacaoEndereco[i] = error;
            this.confirmouCadastro = false;
          }
        } else {
          try {
            await this.$store.dispatch(
              "fornecedorEndereco/putFornecedorEndereco",
              this.fornecedor.FornecedorEndereco[i]
            );
          } catch (error) {
            this.errosValidacaoGeral.push(
              ...this.$utils.retornarValoresJson(error)
            );
            this.errosGerais = error;
            this.errosValidacaoEndereco[i] = error;
            this.confirmouCadastro = false;
          }
        }
      }
    },
    async confirmarTelefone() {
      this.errosValidacaoTelefone = new Array(
        this.fornecedor.FornecedorTelefone.length
      );
      for (var i = 0; i < this.fornecedor.FornecedorTelefone.length; i++) {
        if (this.fornecedor.FornecedorTelefone[i].id === 0) {
          this.fornecedor.FornecedorTelefone[i].id_fornecedor =
            this.fornecedor.id;
          try {
            var ret = await this.$store.dispatch(
              "fornecedorTelefone/postFornecedorTelefone",
              this.fornecedor.FornecedorTelefone[i]
            );
            if (ret.Success === true) {
              this.fornecedor.FornecedorTelefone[i].id = ret.Data.id;
            }
          } catch (error) {
            this.errosValidacaoGeral.push(
              ...this.$utils.retornarValoresJson(error)
            );
            this.errosGerais = error;
            this.errosValidacaoTelefone[i] = error;
            this.confirmouCadastro = false;
          }
        } else {
          try {
            await this.$store.dispatch(
              "fornecedorTelefone/putFornecedorTelefone",
              this.fornecedor.FornecedorTelefone[i]
            );
          } catch (error) {
            this.errosValidacaoGeral.push(
              ...this.$utils.retornarValoresJson(error)
            );
            this.errosGerais = error;
            this.errosValidacaoTelefone[i] = error;
            this.confirmouCadastro = false;
          }
        }
      }
    },
    async confirmarEmail() {
      this.errosValidacaoEmail = new Array(
        this.fornecedor.FornecedorEmail.length
      );
      for (var i = 0; i < this.fornecedor.FornecedorEmail.length; i++) {
        if (this.fornecedor.FornecedorEmail[i].id === 0) {
          this.fornecedor.FornecedorEmail[i].id_fornecedor = this.fornecedor.id;
          try {
            var ret = await this.$store.dispatch(
              "fornecedorEmail/postFornecedorEmail",
              this.fornecedor.FornecedorEmail[i]
            );
            if (ret.Success === true) {
              this.fornecedor.FornecedorEmail[i].id = ret.Data.id;
            }
          } catch (error) {
            this.errosValidacaoGeral.push(
              ...this.$utils.retornarValoresJson(error)
            );
            this.errosGerais = error;
            this.errosValidacaoEmail[i] = error;
            this.confirmouCadastro = false;
          }
        } else {
          try {
            await this.$store.dispatch(
              "fornecedorEmail/putFornecedorEmail",
              this.fornecedor.FornecedorEmail[i]
            );
          } catch (error) {
            this.errosValidacaoGeral.push(
              ...this.$utils.retornarValoresJson(error)
            );
            this.errosGerais = error;
            this.errosValidacaoEmail[i] = error;
            this.confirmouCadastro = false;
          }
        }
      }
    },
    adicionarEmail() {
      this.fornecedor.FornecedorEmail.push({
        id: 0,
        id_fornecedor: 0,
        descricao: "Pessoal",
        email: "",
      });
    },
    async excluirEmail(index) {
      if (this.fornecedor.FornecedorEmail.length > 1) {
        var result = await Swal.fire({
          text: "Deseja remover o registro?",
          icon: "question",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: "Sim, remova!",
          cancelButtonText: "Cancelar",
          customClass: {
            confirmButton: "btn fw-bold btn-primary",
            cancelButton: "btn fw-bold btn-danger",
          },
        });
        if (result.isConfirmed) {
          this.errosGeraisEmail = {};
          this.errosValidacaoEmail = [];
          this.loading = true;

          var id = this.fornecedor.FornecedorEmail[index].id;
          if (id === 0) {
            this.fornecedor.FornecedorEmail.splice(index, 1);
            toast.success("Email excluído com sucesso!", { timeout: 3000 });
          } else {
            try {
              var ret = await this.$store.dispatch(
                "fornecedorEmail/deleteFornecedorEmail",
                id
              );
              if (ret.Success === true) {
                this.fornecedor.FornecedorEmail.splice(index, 1);
                toast.success("Email excluído com sucesso!", {
                  timeout: 3000,
                });
              }
            } catch (error) {
              this.errosGeraisEmail = error;
              this.scroll("fornecedor_email");
            }
          }
          this.loading = false;
        }
      }
    },
    adicionarTelefone() {
      this.fornecedor.FornecedorTelefone.push({
        id: 0,
        id_fornecedor: 0,
        descricao: "Celular",
        telefone: "",
      });
    },
    async excluirTelefone(index) {
      if (this.fornecedor.FornecedorTelefone.length > 1) {
        var result = await Swal.fire({
          text: "Deseja remover o registro?",
          icon: "question",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: "Sim, remova!",
          cancelButtonText: "Cancelar",
          customClass: {
            confirmButton: "btn fw-bold btn-primary",
            cancelButton: "btn fw-bold btn-danger",
          },
        });
        if (result.isConfirmed) {
          this.errosGeraisTelefone = {};
          this.errosValidacaoTelefone = [];
          this.loading = true;

          var id = this.fornecedor.FornecedorTelefone[index].id;
          if (id === 0) {
            this.fornecedor.FornecedorTelefone.splice(index, 1);
            toast.success("Telefone excluído com sucesso!", { timeout: 3000 });
          } else {
            try {
              var ret = await this.$store.dispatch(
                "fornecedorTelefone/deleteFornecedorTelefone",
                id
              );
              if (ret.Success === true) {
                this.fornecedor.FornecedorTelefone.splice(index, 1);
                toast.success("Telefone excluído com sucesso!", {
                  timeout: 3000,
                });
              }
            } catch (error) {
              this.errosGeraisTelefone = error;
              this.scroll("fornecedor_telefone");
            }
          }
          this.loading = false;
        }
      }
    },
    adicionarEndereco() {
      this.fornecedor.FornecedorEndereco.push({
        id: 0,
        id_fornecedor: 0,
        descricao: "Casa",
        endereco: "",
        complemento: "",
        bairro: "",
        numero: "",
        cep: "",
        cidade: "",
        cod_cidade: "",
        uf: "SP",
        pais: "",
        cod_pais: "",
        latitude: "",
        longitude: "",
      });
    },
    async excluirEndereco(index) {
      if (this.fornecedor.FornecedorEndereco.length > 1) {
        var result = await Swal.fire({
          text: "Deseja remover o registro?",
          icon: "question",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: "Sim, remova!",
          cancelButtonText: "Cancelar",
          customClass: {
            confirmButton: "btn fw-bold btn-primary",
            cancelButton: "btn fw-bold btn-danger",
          },
        });
        if (result.isConfirmed) {
          this.errosGeraisEndereco = {};
          this.errosValidacaoEndereco = [];
          this.loading = true;

          var id = this.fornecedor.FornecedorEndereco[index].id;
          if (id === 0) {
            this.fornecedor.FornecedorEndereco.splice(index, 1);
            toast.success("Endereço excluído com sucesso!", { timeout: 3000 });
          } else {
            try {
              var ret = await this.$store.dispatch(
                "fornecedorEndereco/deleteFornecedorEndereco",
                id
              );
              if (ret.Success === true) {
                this.fornecedor.FornecedorEndereco.splice(index, 1);
                toast.success("Endereço excluído com sucesso!", {
                  timeout: 3000,
                });
              }
            } catch (error) {
              this.errosGeraisEndereco = error;
              this.scroll("fornecedor_endereco");
            }
          }
          this.loading = false;
        }
      }
    },
    modalCidades(exibir) {
      this.exibirCidades = exibir;
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal("kt_modal_cidades");
        }, 100);
      }
    },
    exibirModalCidades(exibir, index) {
      this.pesquisaCidadeIndex = index;
      this.modalCidades(exibir);
    },
    confirmarCidade(cidade) {
      this.fornecedor.FornecedorEndereco[this.pesquisaCidadeIndex].cidade =
        cidade.cidade;
      this.fornecedor.FornecedorEndereco[this.pesquisaCidadeIndex].cod_cidade =
        cidade.codcidade;
      this.fornecedor.FornecedorEndereco[this.pesquisaCidadeIndex].uf =
        cidade.uf;
      this.fornecedor.FornecedorEndereco[this.pesquisaCidadeIndex].cod_pais =
        "1058";
      this.fornecedor.FornecedorEndereco[this.pesquisaCidadeIndex].pais =
        "BRASIL";
    },
    modalPaises(exibir) {
      this.exibirPaises = exibir;
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal("kt_modal_paises");
        }, 100);
      }
    },
    exibirModalPaises(exibir, index) {
      this.pesquisaPaisIndex = index;
      this.modalPaises(exibir);
    },
    confirmarPais(pais) {
      this.fornecedor.FornecedorEndereco[this.pesquisaPaisIndex].cod_pais =
        pais.codbacen;
      this.fornecedor.FornecedorEndereco[this.pesquisaPaisIndex].pais =
        pais.descricao;
    },
    async pesquisarCep(i) {
      this.loadingCep = true;
      if (
        this.fornecedor.FornecedorEndereco[i].cep !== null &&
        this.fornecedor.FornecedorEndereco[i].cep != ""
      ) {
        try {
          var ret = await this.$store.dispatch(
            "cep/getCep",
            this.fornecedor.FornecedorEndereco[i].cep
          );
          if (ret.Data !== null) {
            this.fornecedor.FornecedorEndereco[i].endereco =
              ret.Data.logradouro;
            this.fornecedor.FornecedorEndereco[i].bairro = ret.Data.bairro;
            this.fornecedor.FornecedorEndereco[i].complemento =
              ret.Data.complemento;
            this.fornecedor.FornecedorEndereco[i].cod_cidade = ret.Data.ibge;
            this.fornecedor.FornecedorEndereco[i].cidade = ret.Data.localidade
              ? ret.Data.localidade.toUpperCase()
              : "";
            this.fornecedor.FornecedorEndereco[i].uf = ret.Data.uf;
            this.fornecedor.FornecedorEndereco[i].pais = "BRASIL";
            this.fornecedor.FornecedorEndereco[i].cod_pais = "1058";
          }
        } catch (error) {
          await Swal.fire({
            text: "Não foi possível localizar o CEP!",
            icon: "warning",
            buttonsStyling: false,
            confirmButtonText: "OK",
            customClass: {
              confirmButton: "btn fw-bold btn-warning",
            },
          });
        }
      }
      this.loadingCep = false;
    },
    removerFoto() {
      if (this.add === true) {
        this.fornecedor.fotoRemover = "";
      } else {
        this.fornecedor.fotoRemover = this.fornecedor.foto.replace(
          this.$utils.getUrl(),
          ""
        );
      }
      this.fornecedor.foto = "";
      this.fornecedor.formFile = null;
      this.$refs.fileInput.value = null;
    },
    pickFile() {
      let input = this.$refs.fileInput;
      let file = input.files;
      if (file && file[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          if (this.fornecedor.foto !== null) {
            this.fornecedor.fotoRemover = this.fornecedor.foto.replace(
              this.$utils.getUrl(),
              ""
            );
          }

          this.fornecedor.foto = e.target.result;
          this.fornecedor.formFile = file[0];
        };
        reader.readAsDataURL(file[0]);
        this.$emit("input", file[0]);
      }
    },
    async limparFornecedor() {
      this.fornecedor = {
        id: 0,
        codigo: 0,
        nome: "",
        fantasia: "",
        cpf_cnpj: "",
        rg_ie: "",
        contato: "",
        fisica: "J",
        tipo_regime: "0",
        ativo: "1",
        site: "",
        foto: "",
        observacoes: "",
        guid: "",
        id_conta: null,
        id_custo: null,
        formFile: null,
        fotoRemover: "",
        FornecedorEndereco: [
          {
            id: 0,
            id_fornecedor: 0,
            descricao: "Casa",
            endereco: "",
            complemento: "",
            bairro: "",
            numero: "",
            cep: "",
            cidade: "",
            cod_cidade: "",
            uf: "SP",
            pais: "",
            cod_pais: "",
            latitude: "",
            longitude: "",
          },
        ],
        FornecedorTelefone: [
          {
            id: 0,
            id_fornecedor: 0,
            descricao: "Celular",
            telefone: "",
          },
        ],
        FornecedorEmail: [
          {
            id: 0,
            id_fornecedor: 0,
            descricao: "Pessoal",
            email: "",
          },
        ],
      };

      this.errosGerais = {};
      this.errosValidacao = [];
      this.errosValidacaoGeral = [];
      this.errosGeraisTelefone = {};
      this.errosValidacaoTelefone = [];
      this.errosGeraisEndereco = {};
      this.errosValidacaoEndereco = [];
      this.errosGeraisEmail = {};
      this.errosValidacaoEmail = [];
    },
    async carregarFornecedor() {
      var id = 0;
      if (this.modal === true) {
        id = this.idFornecedor;
      } else {
        id = this.$route.params.id;
      }
      try {
        var ret = await this.$store.dispatch("fornecedor/getFornecedor", id);
        if (ret.Success === true) {
          this.fornecedor = ret.Data;

          if (this.fornecedor.foto !== null && this.fornecedor.foto !== "") {
            this.fornecedor.foto = this.$utils.getUrl() + this.fornecedor.foto;
          }
        }
      } catch (error) {
        this.errosGerais = error;
      }
      this.loading = false;
    },
    async asyncData() {
      if (
        (this.$route.name.includes("cadastros/fornecedores/editar") &&
          this.$route.params.id !== undefined) ||
        this.idFornecedor !== 0
      ) {
        this.loading = true;
        this.add = false;
        await this.carregarFornecedor();
      } else {
        this.add = true;
        await this.limparFornecedor();
      }

      this.pesquisaCidadeIndex = 0;
      this.pesquisaPaisIndex = 0;
      this.confirmouCadastro = true;
    },
    scroll(refName) {
      let el = this.$refs[refName];
      if (el) {
        el.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center",
        });
      }
    },
    async verificarRestricoes() {
      if (this.user.User.EmitenteTipoUsuario.EmitenteRestricao != null) {
        this.user.User.EmitenteTipoUsuario.EmitenteRestricao.find((element) => {
          if (element.regra === "Permitir.FornecedorTelefone.Consultar") {
            this.consultarFornecedorTelefone = true;
          }
          if (element.regra === "Permitir.FornecedorTelefone.Incluir") {
            this.adicionarFornecedorTelefone = true;
          }
          if (element.regra === "Permitir.FornecedorTelefone.Alterar") {
            this.editarFornecedorTelefone = true;
          }
          if (element.regra === "Permitir.FornecedorTelefone.Excluir") {
            this.excluirFornecedorTelefone = true;
          }

          if (element.regra === "Permitir.FornecedorEndereco.Consultar") {
            this.consultarFornecedorEndereco = true;
          }
          if (element.regra === "Permitir.FornecedorEndereco.Incluir") {
            this.adicionarFornecedorEndereco = true;
          }
          if (element.regra === "Permitir.FornecedorEndereco.Alterar") {
            this.editarFornecedorEndereco = true;
          }
          if (element.regra === "Permitir.FornecedorEndereco.Excluir") {
            this.excluirFornecedorEndereco = true;
          }

          if (element.regra === "Permitir.FornecedorEmail.Consultar") {
            this.consultarFornecedorEmail = true;
          }
          if (element.regra === "Permitir.FornecedorEmail.Incluir") {
            this.adicionarFornecedorEmail = true;
          }
          if (element.regra === "Permitir.FornecedorEmail.Alterar") {
            this.editarFornecedorEmail = true;
          }
          if (element.regra === "Permitir.FornecedorEmail.Excluir") {
            this.excluirFornecedorEmail = true;
          }
        });
      }
    },
    async pesquisarCNPJ() {
      this.loadingCNPJ = true;
      if (
        this.fornecedor.cpf_cnpj &&
        this.fornecedor.cpf_cnpj !== null &&
        this.fornecedor.cpf_cnpj != ""
      ) {
        try {
          if (this.$utils.validarCPFCNPJ(this.fornecedor.cpf_cnpj)) {
            if (this.fornecedor.cpf_cnpj.replace(/[^\d]/g, "").length === 14) {
              var ret = await this.$utils.consultarCNPJ(
                this.fornecedor.cpf_cnpj
              );
              if (ret.data) {
                const dadosCNPJ = ret.data;
                this.fornecedor.nome = dadosCNPJ.razao_social;
                this.fornecedor.fantasia =
                  dadosCNPJ.estabelecimento.nome_fantasia;
                this.fornecedor.FornecedorEndereco[0].endereco =
                  dadosCNPJ.estabelecimento.logradouro;
                this.fornecedor.FornecedorEndereco[0].complemento =
                  dadosCNPJ.estabelecimento.complemento;
                this.fornecedor.FornecedorEndereco[0].bairro =
                  dadosCNPJ.estabelecimento.bairro;
                this.fornecedor.FornecedorEndereco[0].numero =
                  dadosCNPJ.estabelecimento.numero;
                this.fornecedor.FornecedorEndereco[0].cep =
                  dadosCNPJ.estabelecimento.cep;
                this.fornecedor.FornecedorEndereco[0].cidade =
                  dadosCNPJ.estabelecimento.cidade.nome;
                this.fornecedor.FornecedorEndereco[0].cod_cidade =
                  dadosCNPJ.estabelecimento.cidade.ibge_id.toString();
                this.fornecedor.FornecedorEndereco[0].uf =
                  dadosCNPJ.estabelecimento.estado.sigla;
                this.fornecedor.FornecedorEndereco[0].cod_uf =
                  dadosCNPJ.estabelecimento.estado.id;
                this.fornecedor.FornecedorEndereco[0].pais =
                  dadosCNPJ.estabelecimento.pais.nome;
                this.fornecedor.FornecedorEndereco[0].cod_pais =
                  dadosCNPJ.estabelecimento.pais.id;
                this.fornecedor.email = dadosCNPJ.estabelecimento.email;
                this.fornecedor.pais = dadosCNPJ.estabelecimento.pais.nome;
                if (
                  dadosCNPJ.estabelecimento.inscricoes_estaduais &&
                  dadosCNPJ.estabelecimento.inscricoes_estaduais.length > 0
                ) {
                  this.fornecedor.rg_ie =
                    dadosCNPJ.estabelecimento.inscricoes_estaduais[0].inscricao_estadual;
                }
                this.fornecedor.fisica = "J";
              }
            } else {
              await Swal.fire({
                text: "A consulta é destinada apenas para CNPJ!\r\n\r\nPara pessoa física, informe os dados manualmente.",
                icon: "warning",
                buttonsStyling: false,
                confirmButtonText: "OK",
                customClass: {
                  confirmButton: "btn fw-bold btn-warning",
                },
              });
            }
          } else {
            await Swal.fire({
              text: "O CNPJ informado é inválido!",
              icon: "warning",
              buttonsStyling: false,
              confirmButtonText: "OK",
              customClass: {
                confirmButton: "btn fw-bold btn-warning",
              },
            });
          }
        } catch (error) {
          if (
            error.response &&
            error.response.data &&
            error.response.data.detalhes
          ) {
            await Swal.fire({
              text: error.response.data.detalhes,
              icon: "warning",
              buttonsStyling: false,
              confirmButtonText: "OK",
              customClass: {
                confirmButton: "btn fw-bold btn-warning",
              },
            });
          } else {
            await Swal.fire({
              text: "Não foi possível localizar o CNPJ informado!",
              icon: "warning",
              buttonsStyling: false,
              confirmButtonText: "OK",
              customClass: {
                confirmButton: "btn fw-bold btn-warning",
              },
            });
          }
        }
      }
      this.loadingCNPJ = false;
    },
  },
  watch: {
    $route: {
      handler: "asyncData",
      immediate: true,
    },
  },
  async mounted() {
    await this.verificarRestricoes();
    this.asyncData();
  },
  data() {
    return {
      consultarFornecedorTelefone: false,
      adicionarFornecedorTelefone: false,
      editarFornecedorTelefone: false,
      excluirFornecedorTelefone: false,
      consultarFornecedorEndereco: false,
      adicionarFornecedorEndereco: false,
      editarFornecedorEndereco: false,
      excluirFornecedorEndereco: false,
      consultarFornecedorEmail: false,
      adicionarFornecedorEmail: false,
      editarFornecedorEmail: false,
      excluirFornecedorEmail: false,
      exibirCustos: false,
      exibirContas: false,
      confirmouCadastro: true,
      loading: false,
      loadingCep: false,
      add: false,
      pesquisaCidadeIndex: 0,
      pesquisaPaisIndex: 0,
      errosGerais: {},
      errosValidacao: [],
      errosValidacaoGeral: [],
      errosGeraisTelefone: {},
      errosValidacaoTelefone: [],
      errosGeraisEndereco: {},
      errosValidacaoEndereco: [],
      errosGeraisEmail: {},
      errosValidacaoEmail: [],
      exibirCidades: false,
      cidadeSelecionada: null,
      exibirPaises: false,
      paisSelecionado: null,
      loadingCNPJ: false,
      consultaCep: {
        cep: "",
        endereco: "",
        bairro: "",
        complemento: "",
        cod_cidade: "",
        cidade: "",
        uf: "SP",
        pais: "",
        cod_pais: "",
      },
      fornecedor: {
        id: 0,
        codigo: 0,
        nome: "",
        fantasia: "",
        cpf_cnpj: "",
        rg_ie: "",
        contato: "",
        fisica: "J",
        tipo_regime: "0",
        ativo: "1",
        site: "",
        foto: "",
        observacoes: "",
        guid: "",
        id_conta: null,
        id_custo: null,
        formFile: null,
        fotoRemover: "",
        FornecedorEndereco: [
          {
            id: 0,
            id_fornecedor: 0,
            descricao: "Casa",
            endereco: "",
            complemento: "",
            bairro: "",
            numero: "",
            cep: "",
            cidade: "",
            cod_cidade: "",
            uf: "SP",
            pais: "",
            cod_pais: "",
            latitude: "",
            longitude: "",
          },
        ],
        FornecedorTelefone: [
          {
            id: 0,
            id_fornecedor: 0,
            descricao: "Celular",
            telefone: "",
          },
        ],
        FornecedorEmail: [
          {
            id: 0,
            id_fornecedor: 0,
            descricao: "Pessoal",
            email: "",
          },
        ],
      },
      options: {
        locale: "pt-BR",
        currency: "BRL",
        currencyDisplay: "hidden",
        precision: 2,
        hideCurrencySymbolOnFocus: false,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: false,
        autoDecimalDigits: true,
        autoSign: true,
        useGrouping: true,
        accountingSign: true,
      },
    };
  },
};
</script>

<style>
.imagePreviewWrapper {
  background-size: contain !important;
  background-position: center !important;
}
</style>
